import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import * as RadioGroup from '@radix-ui/react-radio-group';
import { disabledColor, enabledColor } from '../styles';
const classicStyles = {
    container: (disabled) => css({
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row-reverse',
        opacity: disabled ? 0.25 : 1,
        overflow: 'hidden',
        border: 'none',
    }),
    item: (disabled, variant) => css({
        position: 'relative',
        width: variant === 'default' ? 16 : 14,
        height: variant === 'default' ? 16 : 14,
        borderRadius: '50%',
        border: '1px solid grey',
        backgroundColor: disabled ? disabledColor : 'white',
        ':hover': {
            borderColor: disabled ? 'grey' : enabledColor,
        },
    }),
    indicator: css({
        position: 'absolute',
        top: -1,
        left: -1,
        right: -1,
        bottom: -1,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: enabledColor,
        borderRadius: '50%',
    }),
    circle: css({
        width: '40%',
        height: '40%',
        borderRadius: '50%',
        backgroundColor: 'white',
    }),
    label: (disabled) => css({
        cursor: 'pointer',
        lineHeight: 1,
        paddingLeft: 5,
        fontSize: '12px',
        ':hover': {
            '& ~ button': {
                borderColor: disabled ? 'grey' : enabledColor,
            },
        },
    }),
};
export function ClassicRadioItem(props) {
    const { value, label, disabled = false, onSelect, variant, name } = props;
    return (_jsxs("div", { css: classicStyles.container(disabled), children: [_jsx("label", { css: classicStyles.label(disabled), style: {
                    fontSize: variant === 'small' ? '1em' : '1.125em',
                }, htmlFor: `${value}${name}`, children: label }), _jsx(RadioGroup.Item, { css: classicStyles.item(disabled, variant), value: value, id: `${value}${name}`, onClick: () => {
                    if (!disabled)
                        onSelect?.(props);
                }, children: _jsx(RadioGroup.Indicator, { css: classicStyles.indicator, children: _jsx("div", { css: classicStyles.circle }) }) })] }));
}
//# sourceMappingURL=ClassicRadioItem.js.map